import React, {useEffect, useState} from 'react'
import {change_password} from './Update_API'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import Swal from 'sweetalert2'
import {Modal} from 'react-bootstrap'

interface propsDataType {
  setShowChangePassword: (show: boolean) => void, 
  showChangePassword: boolean
}
interface formValuesDataType {
  old_password: string,
    new_password: string,
    confirm_new_password: string,
}
const ChangePassword = ({setShowChangePassword, showChangePassword}: propsDataType) => {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false)
  const [showNewConfirmPassword, setShowNewConfirmPassword] = useState<boolean>(false)
  const [error, setError] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  const closeModalemail = () => {
    setShowChangePassword(false)
    setError('')
    setShowPassword(false)
    setShowNewPassword(false)
    setShowNewConfirmPassword(false)
    formik.resetForm()
  }
  const initialValues = {
    old_password: '',
    new_password: '',
    confirm_new_password: '',
  }
  const validationSchema = Yup.object().shape({
    old_password: Yup.string()
      .min(8, 'Minimum 8 characters')
      .max(50, 'Maximum 50 characters')
      .required('Password is required'),
    new_password: Yup.string()
      .min(8, 'Minimum 8 characters')
      .max(50, 'Maximum 50 characters')
      .required('New password is required'),
    confirm_new_password: Yup.string()
      .oneOf([Yup.ref('new_password'), null], 'New passwords must match')
      .required('Confirm new password is required'),
  })
  const changePassword = async (values: formValuesDataType) => {
    setLoading(true)
    try {
      const {data: res} = await change_password(values.old_password, values.new_password)
      if (res.code === '200') {
        formik.resetForm()
        setShowPassword(false)
        setShowNewPassword(false)
        setShowNewConfirmPassword(false)
        setShowChangePassword(false)
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: res.msg.charAt(0).toUpperCase() + res.msg.slice(1),
          text: res.msg_details,
          allowOutsideClick: true,
        })
      } else {
        setError(`${res.msg.charAt(0).toUpperCase() + res.msg.slice(1)} : ${res.msg_details}`)
      }
    } catch (error: any) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }
  
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      changePassword(values)
    },
  })

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError('')
      }, 2000)
    }
  }, [error])
  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-500px'
      show={showChangePassword}
      onHide={() => setShowChangePassword(false)}
      backdrop={true}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className='modal-content'>
          <div className='modal-header pt-5 pb-5'>
            <h5 className='modal-title'>Reset password</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              aria-label='Close'
              onClick={closeModalemail}
            >
              <i className='bi bi-x-lg' />
            </div>
          </div>
          {/* error msg after failed apis */}
          {error && (
            <div className='h-20px d-flex justify-content-center' style={{backgroundColor: 'red'}}>
              <div className='fv-help-block' style={{color: 'white'}}>
                {error}
              </div>
            </div>
          )}
          <div className='modal-body pb-4'>
            {/*begin::Form Group current Password*/}
            <div className='fv-row mb-2'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Current Password</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Enter current password'
                ></i>
              </label>
              <div className='position-relative'>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className='form-control form-control-lg form-control-solid right-padding'
                  placeholder='Enter current password'
                  {...formik.getFieldProps('old_password')}
                  name='old_password'
                />
                <div
                  className={'position-absolute end-0 top-0 py-4 px-4'}
                  style={{fontWeight: '600'}}
                >
                  {showPassword ? (
                    <i
                      className='bi bi-eye-fill fs-1 text-primary'
                      onClick={() => setShowPassword(false)}
                    ></i>
                  ) : (
                    <i
                      className='bi bi-eye-slash-fill fs-1 text-primary'
                      onClick={() => setShowPassword(true)}
                    ></i>
                  )}
                </div>
              </div>
              <div className='h-20px'>
                {formik.touched.old_password && formik.errors.old_password && (
                  <div className='fv-help-block color-red'>{formik.errors.old_password}</div>
                )}
              </div>
            </div>
            {/*end::Form Group current Password*/}
            {/*begin::Form Group New Password*/}
            <div className='fv-row mb-2'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>New Password</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Enter new password'
                ></i>
              </label>
              <div className='position-relative'>
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  className='form-control form-control-lg form-control-solid right-padding'
                  placeholder='Enter new password'
                  {...formik.getFieldProps('new_password')}
                  name='new_password'
                />
                <div
                  className={'position-absolute end-0 top-0 py-4 px-4'}
                  style={{fontWeight: '600'}}
                >
                  {showNewPassword ? (
                    <i
                      className='bi bi-eye-fill fs-1 text-primary'
                      onClick={() => setShowNewPassword(false)}
                    ></i>
                  ) : (
                    <i
                      className='bi bi-eye-slash-fill fs-1 text-primary'
                      onClick={() => setShowNewPassword(true)}
                    ></i>
                  )}
                </div>
              </div>
              <div className='h-20px'>
                {formik.touched.new_password && formik.errors.new_password && (
                  <div className='fv-help-block color-red'>{formik.errors.new_password}</div>
                )}
              </div>
            </div>
            {/*end::Form Group New Password*/}
            {/*begin::Form Group Confirm New Password*/}
            <div className='fv-row mb-2'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Confirm New Password</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Enter new password'
                ></i>
              </label>
              <div className='position-relative'>
                <input
                  type={showNewConfirmPassword ? 'text' : 'password'}
                  className='form-control form-control-lg form-control-solid right-padding'
                  placeholder='Confirm new password'
                  {...formik.getFieldProps('confirm_new_password')}
                  name='confirm_new_password'
                />
                <div
                  className={'position-absolute end-0 top-0 py-4 px-4'}
                  style={{fontWeight: '600'}}
                >
                  {showNewConfirmPassword ? (
                    <i
                      className='bi bi-eye-fill fs-1 text-primary'
                      onClick={() => setShowNewConfirmPassword(false)}
                    ></i>
                  ) : (
                    <i
                      className='bi bi-eye-slash-fill fs-1 text-primary'
                      onClick={() => setShowNewConfirmPassword(true)}
                    ></i>
                  )}
                </div>
              </div>
              <div className='h-20px'>
                {formik.touched.confirm_new_password && formik.errors.confirm_new_password && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.confirm_new_password}
                  </div>
                )}
              </div>
            </div>
            {/*end::Form Group Confirm New Password*/}
          </div>

          <div className='modal-footer pt-2 pb-2 mb-0 d-flex justify-content-center'>
            <button type='submit' className='btn btn-primary' disabled={loading}>
              {loading ? (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Processing...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              ) : (
                'Save'
              )}
            </button>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default ChangePassword
